// extracted by mini-css-extract-plugin
export default {"additionalInfo":"OrderAdditionalInfo_additionalInfo__SvGgU"};